import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './index.scss';
import ReportHeader from './ReportHeader/ReportHeader';
import ReportFilter from './ReportFilter/ReportFilter';
import ReportsListTable from './ReportsListTable/ReportsListTable';
import useReportList from './hooks/useReportList';
import GenericButton from '../common/button';
import { Col, Form, Modal, Row } from 'react-bootstrap';
import { ToastContainer } from 'react-toastify';
import { Link } from 'react-router-dom';

const Reports = () => {
  const { t } = useTranslation();
  const {
    pageSize,
    columnNames,
    expiry,
    handleSendReportsEmail,
    handleDeleteReports,
    reportsData,
    isServerErrorOnList,
    setShowModal,
    showModal,
    resetReportFilters,
    handleClose,
  } = useReportList();

  useEffect(() => {
    return () => {
      resetReportFilters();
    };
  }, []);

  return (
    <div>
      <div className="reports">
        <div className="container-offset">
          <ReportHeader />
          <div className="devider" />
        </div>
        <ReportFilter />
        <div className="container-offset">
          <ReportsListTable
            className="account-table"
            columns={columnNames}
            data={reportsData?.data}
            keyField={columnNames}
            pageSizeCount={reportsData?.pagination?.pageSize}
          />
          {isServerErrorOnList || (
            <>
              <div className="report-disclaimer-text">
                All Reports will expire in {expiry ? expiry : '30'} day
                {Number(expiry) > 1 && 's'} from the date of generation.
              </div>
              <div className="send-delete-button-container">
                <div>
                  <GenericButton
                    variant="secondary"
                    tabIndex={0}
                    ariaLabel="Click to send selected reports on your registered email."
                    onClick={() => handleSendReportsEmail()}
                    disabled={!(reportsData?.selectedReports?.length > 0)}
                    className={
                      reportsData?.selectedReports?.length > 0
                        ? 'button-border'
                        : 'reports-disabled-button'
                    }
                  >
                    {t('admin.pages.reports.send_button_text')}
                  </GenericButton>
                </div>
                <div>
                  <Form.Group
                    className="form-block mb-0"
                    controlId="buttonsFormGroup"
                  >
                    <Col>
                      <Modal
                        show={showModal}
                        onHide={handleClose}
                        centered
                        className="modal-class"
                      >
                        <Modal.Header closeButton className="header-class">
                          <Modal.Title className="title-class">
                            Delete Request
                          </Modal.Title>
                        </Modal.Header>

                        <Modal.Body className="body-class">
                          <Form.Group controlId="linkDelete">
                            <Form.Label>
                              {reportsData?.selectedReports?.length > 1
                                ? `Are you sure you want to delete these ${reportsData?.selectedReports?.length} reports? This cannot be undone.`
                                : 'Are you sure you want to delete this reports? This cannot be undone.'}
                            </Form.Label>
                          </Form.Group>
                        </Modal.Body>

                        <Modal.Footer className="admin bg-white footer-class">
                          <Link
                            className="cancle-modal-reports-admin"
                            onClick={() => setShowModal(false)}
                          >
                            Cancel
                          </Link>

                          <GenericButton
                            variant="primary"
                            onClick={() => handleDeleteReports()}
                          >
                            CONFIRM
                          </GenericButton>
                        </Modal.Footer>
                      </Modal>
                    </Col>
                    <Col className="p-0">
                      <GenericButton
                        variant="secondary"
                        tabIndex={0}
                        ariaLabel="Click to delete selected reports."
                        onClick={() => setShowModal(true)}
                        disabled={!(reportsData?.selectedReports?.length > 0)}
                        className={
                          reportsData?.selectedReports?.length > 0
                            ? 'button-border'
                            : 'reports-disabled-button'
                        }
                      >
                        {t('admin.pages.reports.delete_button_text')}
                      </GenericButton>
                    </Col>
                  </Form.Group>
                  <div className="toastify">
                    <ToastContainer
                      position="top-center"
                      autoClose={5000}
                      hideProgressBar={false}
                      newestOnTop={false}
                      closeOnClick
                      rtl={false}
                      pauseOnFocusLoss
                      draggable
                      pauseOnHover
                    />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Reports;
